var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4H1C0.4 4 0 4.4 0 5V15C0 15.6 0.4 16 1 16H9C9.6 16 10 15.6 10 15V5C10 4.4 9.6 4 9 4Z",
    fill: "#939393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 0H3V2H12V13H14V1C14 0.4 13.6 0 13 0Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a5c46aa3077e2c22ac7193f5329aee50.svg";
export { ForwardRef as ReactComponent };